// extracted by mini-css-extract-plugin
export default {"selected":"f234574ade","un":"_69289716da"};